// extracted by mini-css-extract-plugin
export var graphic = "ResearchAndDevelopmentLayout-module--graphic--cLjT1";
export var stages = "ResearchAndDevelopmentLayout-module--stages--08Stf";
export var items = "ResearchAndDevelopmentLayout-module--items--iPVLH";
export var itemLink = "ResearchAndDevelopmentLayout-module--itemLink--D8aCu";
export var itemLinkContent = "ResearchAndDevelopmentLayout-module--item-link-content--rsYEL";
export var seeAlsoContent = "ResearchAndDevelopmentLayout-module--see-also-content--7Wmv6";